import React, { useEffect, useState } from "react";
import RequiredLabel from "../RequiredLabel";

const initialErrorData = {
  pradeshName: "",
  mandalName: "",
  areaName: "",
  designationName: "",
};

const Steps5 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState(initialErrorData);
  const [filteredMandals, setFilteredMandals] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);

  useEffect(() => {
    setFormData(details || {});
  }, [details]);

  // Filter mandals based on selected pradesh
  useEffect(() => {
    if (formData?.pradeshName) {
      const selectedPradesh = initialData?.pradesh?.find(
        (p) => p.list_value === formData.pradeshName
      );
      if (selectedPradesh) {
        const mandalsForPradesh = initialData?.mandal?.filter(
          (m) => m.parentid === selectedPradesh.masterlistid
        );
        setFilteredMandals(mandalsForPradesh || []);

        // Reset mandal and area if pradesh changes
        setFormData((prev) => ({
          ...prev,
          mandalName: "",
          areaName: "",
        }));
        setFilteredAreas([]);
      }
    } else {
      setFilteredMandals([]);
    }
  }, [formData?.pradeshName, initialData]);

  // Filter areas based on selected mandal
  useEffect(() => {
    if (formData?.mandalName) {
      const selectedMandal = initialData?.mandal?.find(
        (m) => m.list_value === formData.mandalName
      );
      if (selectedMandal) {
        const areasForMandal = initialData?.area?.filter(
          (a) => a.parentid === "76"
        );
        setFilteredAreas(areasForMandal || []);

        // Reset area if mandal changes
        setFormData((prev) => ({
          ...prev,
          areaName: "",
        }));
      }
    } else {
      setFilteredAreas([]);
    }
  }, [formData?.mandalName, initialData]);

  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      if (name === "disabilityCheck") {
        setFormData({ ...formData, [name]: e.target.checked });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }

    // Clear errors for the field if it is filled
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  // Validate the form fields
  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    if (!formData.pradeshName || formData.pradeshName.trim() === "") {
      newErrors.pradeshName = "Please enter Pradesh Name";
      isValid = false;
    }

    if (!formData.mandalName || formData.mandalName.trim() === "") {
      newErrors.mandalName = "Please select Mandal Name";
      isValid = false;
    }

    if (!formData.areaName || formData.areaName.trim() === "") {
      newErrors.areaName = "Please select Area Name";
      isValid = false;
    }

    if (!formData.designationName || formData.designationName.trim() === "") {
      newErrors.designationName = "Please select Designation Name";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      console.log("Form Data:", formData);
      detailsSet(formData);
      setCount(count + 1);
      completeCurrentStep(count);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-4 main p-4 border rounded-4 bg-white">
        <div className="row">
          <div className="col-md-6">
            <RequiredLabel htmlFor="Pradesh Name">Pradesh Name</RequiredLabel>
            <select
              name="pradeshName"
              value={formData?.pradeshName || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="">
                Select...
              </option>
              {initialData?.pradesh?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.pradeshName && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.pradeshName}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <RequiredLabel htmlFor="Professional Education">
              Mandal Name
            </RequiredLabel>
            <select
              name="mandalName"
              value={formData?.mandalName || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
              disabled={!formData?.pradeshName}
            >
              <option className="inputText" value="">
                Select...
              </option>
              {filteredMandals.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              ))}
            </select>
            {errors?.mandalName && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.mandalName}
              </span>
            )}
          </div>

          <div className="col-md-6 mt-4">
            <RequiredLabel htmlFor="areaname">Area Name</RequiredLabel>
            <select
              name="areaName"
              value={formData?.areaName || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
              disabled={!formData?.mandalName}
            >
              <option className="inputText" value="">
                Select...
              </option>
              {filteredAreas.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              ))}
            </select>
            {errors?.areaName && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.areaName}
              </span>
            )}
          </div>

          <div className="col-md-6 mt-4">
            <RequiredLabel htmlFor="name">Designation Name</RequiredLabel>
            <select
              name="designationName"
              value={formData?.designationName || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="">
                Select...
              </option>
              {initialData?.designation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.designationName && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.designationName}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 5 && (
          <button type="submit" className="rounded-5 btnBlue">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps5;
